/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OIDCTokensInfo } from './OIDCTokensInfo';
import {
    OIDCTokensInfoFromJSON,
    OIDCTokensInfoFromJSONTyped,
    OIDCTokensInfoToJSON,
    OIDCTokensInfoToJSONTyped,
} from './OIDCTokensInfo';

/**
 * 
 * @export
 * @interface TokenContainer
 */
export interface TokenContainer {
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    aud?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof TokenContainer
     */
    iat?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenContainer
     */
    exp?: number;
    /**
     * 
     * @type {number}
     * @memberof TokenContainer
     */
    nbf?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    iss?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    sub?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenContainer
     */
    user_token: string;
    /**
     * 
     * @type {Array<OIDCTokensInfo>}
     * @memberof TokenContainer
     */
    oidc_tokens?: Array<OIDCTokensInfo>;
}

/**
 * Check if a given object implements the TokenContainer interface.
 */
export function instanceOfTokenContainer(value: object): value is TokenContainer {
    if (!('user_token' in value) || value['user_token'] === undefined) return false;
    return true;
}

export function TokenContainerFromJSON(json: any): TokenContainer {
    return TokenContainerFromJSONTyped(json, false);
}

export function TokenContainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenContainer {
    if (json == null) {
        return json;
    }
    return {
        
        'aud': json['aud'] == null ? undefined : json['aud'],
        'id': json['id'] == null ? undefined : json['id'],
        'iat': json['iat'] == null ? undefined : json['iat'],
        'exp': json['exp'] == null ? undefined : json['exp'],
        'nbf': json['nbf'] == null ? undefined : json['nbf'],
        'iss': json['iss'] == null ? undefined : json['iss'],
        'sub': json['sub'] == null ? undefined : json['sub'],
        'user_token': json['user_token'],
        'oidc_tokens': json['oidc_tokens'] == null ? undefined : ((json['oidc_tokens'] as Array<any>).map(OIDCTokensInfoFromJSON)),
    };
}

export function TokenContainerToJSON(json: any): TokenContainer {
    return TokenContainerToJSONTyped(json, false);
}

export function TokenContainerToJSONTyped(value?: TokenContainer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aud': value['aud'],
        'id': value['id'],
        'iat': value['iat'],
        'exp': value['exp'],
        'nbf': value['nbf'],
        'iss': value['iss'],
        'sub': value['sub'],
        'user_token': value['user_token'],
        'oidc_tokens': value['oidc_tokens'] == null ? undefined : ((value['oidc_tokens'] as Array<any>).map(OIDCTokensInfoToJSON)),
    };
}

